import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { Button, Bubble } from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook'
import SelectorMultiple from '@/pages/dashboard/components/SelectorMultiple';
import RangeDayMonthSelector from '@/pages/dashboard/components/RangeDayMonthSelector';
import TimePicker from '@/pages/dashboard/components/TimePicker';
import RegionSelector from '@/pages/dashboard/components/RegionSelector';
import RangePicker from '@/pages/home/components/RangePicker';

import { FORM_MAP, CUSTOMIZE, TIMETYPETODATE } from './_config/constant';
import lockOpenIcon from '@/pages/dashboard/assets/svg/lock-open.svg'
import lockCloseIcon from '@/pages/dashboard/assets/svg/lock-close.svg'
import { FilterProps } from './types';
import useFilter from './hooks/useFilter';
import { PUBG_GAME_CODE_LIST } from '@/pages/dashboard/_config/constant';
import './index.scss'

const RenderComponent = (props) => {
  const { renderInput, inputList, loading } = props

  return (
    <>
      {!loading && renderInput(inputList)}
    </>
  )
}

const Filter = (props: FilterProps) => {
  const {
    isLocal = true,
    noCache = false,
    topSlot, //类似于竞品页面筛选器上方的时间切换功能
    options,
    inputList,
    confirmDisabled = false,
    gameCode = '',
    latestDate,
    timeTypeList = ['date', 'week', 'month'],
    defaultValue,
    isExpand,
    showBubble,
    setChangeFormValue,
    closeFunc,
  } = props;

  const popularList = inputList?.map(item => {
    if (item?.type === 'region') {
      return item?.options?.popularList
    }
  })
  const {
    loading,
    formState,
    isLockFilter,
    dateObj,
    dispatch,
    onLockChange,
    onDayMonthChange,
    onRangeTimeChange,
    onSingleTimeChange,
    onContrastDayChange,
    onZoneChange,
    onRegionChange,
    onSystemChange,
    onLaguageChange,
    onChannelChange,
    onTrackingDayChange,
    onNetworkTypeChange,
    onMediaChannelChange,
    onCustomizedInputChange,
    onSwitchDatePickerChange,
    handleConfirm,
    handleReset
  } = useFilter(props);

  const { locale, getLocalText } = useLocal('filter')

  const {
    time: rangeTime,
    singleTime,
    dayMonth,
    contrastDay,
    zone,
    region,
    channel,
    system,
    language,
    networkType,
    mediaChannel,
  } = options || {};
  const { timeType } = formState;
  const isPUBGM = PUBG_GAME_CODE_LIST.includes(gameCode);
  useEffect(() => {
    setChangeFormValue(formState)
  }, [formState])
  // 内置筛选器
  const getInput = (type, key, _option) => {
    const sortByEnNameArr = ['channel', 'system', 'zone']
    const { options: filterOptions } = _option ?? {}
    const option = {
      ...(_option ?? {}),
      options: [...(filterOptions ?? [])]?.sort((a, b) => {
        return a?.enText?.localeCompare(b?.enText)
      }),
    }
    if (sortByEnNameArr?.includes(type)) {
      // 按英文名称的字母排序
      option?.options?.sort((a, b) => {
        return a?.enText?.localeCompare(b?.enText)
      })
    }
    const startYear = Number(moment().subtract(5, 'year').format('YYYY'))
    const year = moment().year();
    const yearToDate = moment(`${year}-01-01`).format('YYYY-MM-DD')
    const allOfTime = moment(`${startYear}-01-01`).format('YYYY-MM-DD')

    const inputMap = {
      rangeTime: (
        <div className='search-item search-item-date' key={key}>
          <RangePicker
            latestDate={latestDate}
            value={[
              moment(formState[key ?? FORM_MAP.RANGE_TIME]?.[0]),
              moment(formState[key ?? FORM_MAP.RANGE_TIME]?.[1])
            ]}
            type={TIMETYPETODATE[formState[`${key}_timeType`] || timeType]}
            startOfTime='2010-01-01'
            className="search-border"
            defaultValue={
              rangeTime?.rangeDefualt ||
              option?.rangeDefualt ||
              defaultValue?.rangeDefualt
            }
            typeList={timeTypeList}
            showSelectType={timeTypeList?.length > 1}
            startOfWeek={1}
            language={locale === 'zh-CN' ? 'cn' : 'en'}
            {...rangeTime}
            {...(option || {})}
            isLocal={isLocal}
            onChange={(value, type) => {
              onRangeTimeChange(value, type, key === FORM_MAP.RANGE_TIME ? null : key, option?.onChange)
            }}
          />
        </div>
      ),
      rangeDayMonth: (
        <RangeDayMonthSelector
          matchButtonWidth
          className='search-item'
          value={formState[FORM_MAP.DAY_MONTH]}
          defaultValue={formState[FORM_MAP.DAY_MONTH]}
          onConfirm={onDayMonthChange}
          {...(dayMonth || {})}
        />
      ),
      singleTime: (
        <TimePicker
          matchButtonWidth
          className='search-item'
          comKey={key}
          locale={locale}
          onConfirm={(value) => onSingleTimeChange(value, key)}
          defaultValue={formState[FORM_MAP.SINGLE_TIME]}
          value={formState[FORM_MAP.SINGLE_TIME]}
          {...(singleTime || {})}
          {...(option || {})}
        />
      ),
      contrastDay: (
        <TimePicker
          matchButtonWidth
          className={`search-item dtb-datepicker-input-prefix ${locale === 'zh-CN' ? 'dtb-language-cn' : ''}`}
          comKey={key}
          locale={locale}
          onConfirm={(value) => onContrastDayChange(value, key)}
          defaultValue={formState[FORM_MAP.CONTRAST_DAY]}
          value={formState[FORM_MAP.CONTRAST_DAY]}
          titleName={getLocalText('filter_contrast')}
          {...(contrastDay || {})}
          {...(option || {})}
        />
      ),
      zone: (
        <SelectorMultiple
          matchButtonWidth
          className='search-item'
          key={FORM_MAP.ZONE}
          label={getLocalText('selector_multiple_component_zone_label', {}, false)}
          allDescribe={getLocalText('selector_multiple_component_zone_all_describe', {}, false)}
          allInfo={getLocalText('selector_multiple_component_zone_all_info', {}, false)}
          value={formState[FORM_MAP.ZONE]}
          onChange={(value, showValue) => onZoneChange(value, key, showValue)}
          {...(zone || {})}
          {...(option || {})}
        />
      ),
      region: (
        <RegionSelector
          matchButtonWidth
          key={FORM_MAP.REGION}
          className={'search-items-country'}
          value={formState[FORM_MAP.REGION]}
          // regionCountry={regionList ?? []}
          onChange={(value) => onRegionChange(value, key)}
          locale={locale}
          popularList={popularList}
          globalMessageHidden={false}
          globalMsg={getLocalText('region_selector_global_message', {}, false)}
          {...(region || {})}
          {...(option || {})}
          regionCountry={option?.options ?? option?.regionCountry}
        />
      ),
      channel: (
        <SelectorMultiple
          matchButtonWidth
          className='search-item'
          key={FORM_MAP.CHANNEL}
          label={getLocalText('selector_multiple_component_channel_label', {}, false)}
          allDescribe={getLocalText('selector_multiple_component_channel_all_describe', {}, false)}
          allInfo={isPUBGM ?
            <div className="text-multiple-line-wrap">{getLocalText('selector_multiple_component_channel_all_info_pubgm', {}, false)}</div> :
            getLocalText('selector_multiple_component_channel_all_info', {}, false)}
          value={formState[FORM_MAP.CHANNEL]}
          onChange={(value) => onChannelChange(value, key)}
          {...(channel || {})}
          {...(option || {})}
        />
      ),
      system: (
        <SelectorMultiple
          matchButtonWidth
          className='search-item'
          key={FORM_MAP.SYSTEM}
          label={getLocalText('selector_multiple_component_system_label', {}, false)}
          allDescribe={getLocalText('selector_multiple_component_system_all_describe', {}, false)}
          allInfo={getLocalText('selector_multiple_component_system_all_info', {}, false)}
          value={formState[FORM_MAP.SYSTEM]}
          onChange={(value) => onSystemChange(value, key)}
          {...(system || {})}
          {...(option || {})}
        />
      ),
      lang: (
        <SelectorMultiple
          matchButtonWidth
          className='search-item'
          key={FORM_MAP.LANGUAGE}
          label={getLocalText('selector_multiple_component_language_label', {}, false)}
          allDescribe={getLocalText('selector_multiple_component_language_all_describe', {}, false)}
          allInfo={getLocalText('selector_multiple_component_language_all_info', {}, false)}
          value={formState[FORM_MAP.LANGUAGE]}
          onChange={(value) => onLaguageChange(value, key === 'lang' ? 'language' : key)}
          {...(language || {})}
          {...(option || {})}
        />
      ),
      networkType: (
        <SelectorMultiple
          matchButtonWidth
          className='search-item'
          key={FORM_MAP.NETWORK_TYPE}
          label={getLocalText('selector_multiple_component_network_label', {}, false)}
          allDescribe={getLocalText('selector_multiple_component_network_all_describe', {}, false)}
          allInfo={getLocalText('selector_multiple_component_network_all_info', {}, false)}
          value={formState[FORM_MAP.NETWORK_TYPE]}
          onChange={(value) => onNetworkTypeChange(value, key)}
          {...(networkType || {})}
          {...(option || {})}
        />
      ),
      mediaChannel: (
        <SelectorMultiple
          matchButtonWidth
          className='search-item'
          key={FORM_MAP.MEDIA_CHANNEL}
          label={getLocalText('selector_multiple_component_media_label', {}, false)}
          allDescribe={getLocalText('selector_multiple_component_media_all_describe', {}, false)}
          allInfo={getLocalText('selector_multiple_component_media_all_info', {}, false)}
          value={formState[FORM_MAP.MEDIA_CHANNEL]}
          onChange={(value) => onMediaChannelChange(value, key)}
          {...(mediaChannel || {})}
          {...(option || {})}
        />
      )
    }

    return inputMap[type]
  }

  // 自定义筛选器
  const getInputCustomized = (component) => {
    if (!component) return null
    return component(dispatch)
  }

  // 渲染筛选器
  const renderInput = (inputList) => (
    inputList?.map(({ type, key, options, component }) => {
      const buildInput = type === CUSTOMIZE ?
        getInputCustomized.bind(this, component) :
        getInput.bind(this, type, key, options)

      return buildInput()
    })
  )

  const key = noCache ? {} : {
    key: JSON.stringify({
      options,
      inputList,
      isLocal
    })
  }

  return (
    <div className={`mod-filter ${props.className}`}>
      {topSlot}
      <div className='mod-filter__inner'>
        <RenderComponent
          // key={JSON.stringify({
          //   options,
          //   inputList,
          //   isLocal
          // })}
          {...key}
          renderInput={renderInput}
          inputList={inputList}
          loading={loading}
        />
      </div>
      <div className='margin-t-10 dbd-filter-expand-content-button'>
        <Bubble
          visible={showBubble}
          arrowPointAtCenter
          dark
          placement="top"
          style={{ maxWidth: 450 }}
          content={getLocalText(`lock_expend_message`)}
        >
          <Button
            type="primary" className='margin-r filter-tea-btn'
            onClick={handleConfirm}
            loading={loading}
            disabled={confirmDisabled}
          >
            {
              getLocalText('confirm')
            }
          </Button>
        </Bubble>
        <Button type="weak" className='margin-r filter-tea-btn'
          onClick={handleReset}
          loading={loading}
        >
          {
            getLocalText('reset')
          }
        </Button>
        <Bubble
          dark
          placement="top"
          content={getLocalText('save_setting')}>
          <Button type="weak" className='tea-btn--weak'>
            {getLocalText('save_setting')}
          </Button>
        </Bubble>
        {
          isExpand && <div
            className={`dbd-filter-content-title-button close-button`}
            onClick={closeFunc}
          >
            {getLocalText(`close_message`)}
            <div className='dbd-filter-content-title-button-down' />
          </div>
        }
      </div>


    </div>
  )
}

export default Filter
